import { LineChart, Line, YAxis, ResponsiveContainer } from "recharts";

export default function Sparkline({ history = [], up = true }) {
  const data = (history || []).map((h, i) => ({ i, p: h.p }));
  if (data.length < 2) {
    return <div className="h-8 w-full flex items-center text-[10px] text-[#52525b] font-mono">no data</div>;
  }
  const color = up ? "#22c55e" : "#ef4444";
  return (
    <div className="h-8 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
          <YAxis domain={["dataMin", "dataMax"]} hide />
          <Line type="monotone" dataKey="p" stroke={color} strokeWidth={1.5} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
